import React from 'react';
import './FabCallButton.scss';
import useAnalytics from '../hooks/useAnalytics';

const FabCallButton = () => {
  const { trackCallButtonClick } = useAnalytics();

  const handleCallClick = () => {
    trackCallButtonClick('fab_call_button');
  };

  return (
    <a
      href="tel:+905322944005"
      className="fab-call-btn"
      aria-label="Telefon ile ara"
      onClick={handleCallClick}
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="white" fillOpacity="0"/>
        <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z" fill="white"/>
      </svg>
    </a>
  );
};

export default FabCallButton; 